import clsx from 'clsx';
import type { ComponentPropsWithRef } from 'react';

import { Link } from '@commons/i18n/navigation';

import Text from '../Text';
import styles from './index.module.scss';

// Type definition for the Tag component properties.

type Props = ComponentPropsWithRef<typeof Text> & {
  inversed?: boolean;
  active?: boolean;
  disableHover?: boolean;
  link?: string;
  variant?: 'primary' | 'secondary' | 'tertiary';
};

/**
 * Tag component.
 */

export const Tag = (props: Props) => {
  const {
    variant = 'primary',
    link,
    inversed = false,
    active,
    disableHover = false,
    children,
    className,
    style,
    ref,
    ...rest
  } = props;

  const classes = clsx(
    styles.tag,
    styles[variant],
    inversed && styles.inverse,
    active && styles.active,
    disableHover && styles.disableHover,
    className
  );

  const renderedTag = (
    <Text
      as="span"
      level="label-md"
      marginBottom="none"
      className={classes}
      style={style}
      ref={ref}
      {...rest}
    >
      {children}
    </Text>
  );

  if (link) {
    return <Link href={link}>{renderedTag}</Link>;
  }

  return renderedTag;
};

export default Tag;
